import { useEffect, useState } from 'react';
import useDebounce from '@teetsh/app/src/utils/useDebounce';
import { Pyramide } from 'types/pyramide';
import useUpdatePyramide from 'queries/pyramides/useUpdatePyramide';

export function useUpdatePyramideDebounce(
  pyr: Pyramide,
): [Pyramide, (v: Pyramide) => void] {
  const [pyramide, setPyramide] = useState<Pyramide>(pyr);
  const updatePyramide = useUpdatePyramide({ pyramideId: pyr.id });
  const debouncedSave = useDebounce(
    nextValue => updatePyramide(nextValue),
    500,
  );
  useEffect(() => {
    setPyramide(pyr);
  }, [JSON.stringify(pyr)]);

  const handleChange = (v: Pyramide) => {
    setPyramide(v);
    debouncedSave(v);
  };
  return [pyramide, handleChange];
}
